import { Box, Container } from "@mui/material";
import { CustomerListTable } from "./pages/CustomerListTable";
import { CustomerToolbar } from "./pages/CustomerToolbar";

export function CustomerUICard() {
  return (
    <>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 4,
        }}
      >
        <Container maxWidth={false}>
          <CustomerToolbar />
          <Box sx={{ mt: 3 }}>
            <CustomerListTable />
          </Box>
        </Container>
      </Box>
    </>
  );
}
